__turbopack_context__.v({
  "clearSearchBtnIcon": "SearchModal-module-scss-module__z5Dnqa__clearSearchBtnIcon",
  "modalButton": "SearchModal-module-scss-module__z5Dnqa__modalButton",
  "modalButtonClear": "SearchModal-module-scss-module__z5Dnqa__modalButtonClear",
  "modalButtonDone": "SearchModal-module-scss-module__z5Dnqa__modalButtonDone",
  "modalInput": "SearchModal-module-scss-module__z5Dnqa__modalInput",
  "noSearchWalletsText": "SearchModal-module-scss-module__z5Dnqa__noSearchWalletsText",
  "removeWalletBtn": "SearchModal-module-scss-module__z5Dnqa__removeWalletBtn",
  "searchBtn": "SearchModal-module-scss-module__z5Dnqa__searchBtn",
  "searchBtnActive": "SearchModal-module-scss-module__z5Dnqa__searchBtnActive",
  "searchWalletDisplay": "SearchModal-module-scss-module__z5Dnqa__searchWalletDisplay",
  "searchWalletDisplayBtn": "SearchModal-module-scss-module__z5Dnqa__searchWalletDisplayBtn",
  "shake": "SearchModal-module-scss-module__z5Dnqa__shake",
  "shakeWalletInput": "SearchModal-module-scss-module__z5Dnqa__shakeWalletInput",
});
